import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import InfoIcon from '@mui/icons-material/Info';

import type { CreationStatus } from './types/creation-status.type';

interface Props {
  readonly infoMessage?: string;
  readonly isInfoAWarning?: boolean;
  readonly onRetry?: () => void;
  readonly status: CreationStatus;
}

export const CreationStatusIndicator = ({
  infoMessage,
  isInfoAWarning,
  onRetry,
  status,
}: Readonly<Props>) => {
  if (status === 'pending') {
    return <CircularProgress size={18} />;
  }

  return (
    <Stack direction="row" sx={{ alignItems: 'center', gap: 0.5 }}>
      {status === 'success' ? (
        <CheckCircleIcon color="success" fontSize="small" />
      ) : (
        <CancelIcon color="error" fontSize="small" />
      )}
      {infoMessage ? (
        <Tooltip title={infoMessage}>
          <InfoIcon
            color={isInfoAWarning ? 'warning' : 'error'}
            fontSize="small"
          />
        </Tooltip>
      ) : null}
      {onRetry ? (
        <Tooltip title="Réessayer">
          <IconButton aria-label="Réessayer" onClick={onRetry} size="small">
            <AutorenewIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      ) : null}
    </Stack>
  );
};
